"use client";
import React from "react";
import { Link } from "react-router-dom";
import Map3 from "../Images/CCA-Abstract-Shapes-08.jpg";
import {
  FaLaptop,
  FaFileAlt,
  FaUserAlt,
  FaDatabase,
  FaHeadset,
  FaSyncAlt,
  FaArrowRight,
  FaCalculator,
  FaShieldAlt,
  FaChartLine,
  FaClock,
  FaUsers,
  FaFileInvoiceDollar,
  FaCheck
} from "react-icons/fa";

function MapBanner({ title, pageName, bgImage, subtitle }) {
  const features = [
    { text: "Online Platforms", icon: <FaLaptop /> },
    { text: "Preparation of Documents", icon: <FaFileAlt /> },
    { text: "User-Friendly Interfaces", icon: <FaUserAlt /> },
    { text: "Data Import and Prefill Features", icon: <FaDatabase /> },
    { text: "Prompt Assistance and Support", icon: <FaHeadset /> },
    { text: "Regular Updates and Compliance", icon: <FaSyncAlt /> },
  ];

  return (
    <section className="map-banner-exact">
      {/* BACKGROUND ELEMENTS */}
      <div className="bg-pattern-dots"></div>
      <div className="bg-blob-right"></div>

      <div className="hero-container">
        <div className="row align-items-center h-100">

          {/* LEFT CONTENT */}
          <div className="col-lg-6 col-xl-6 left-content-wrapper">
            <div className="content-left">
              <div className="pill-tag">
                <div className="tag-icon-box">
                  <FaFileInvoiceDollar />
                </div>
                <span>Smart Tax Solutions</span>
              </div>

              <h2 className="main-heading">
                <span className="d-block text-nowrap">Explore services for</span>
                <span className="text-blue d-block">{title || "Income Tax Returns"}</span>
              </h2>

              <p className="sub-desc">
                {subtitle || "A smarter, faster and hassle-free way to manage your business compliance and registration online."}
              </p>

              <div className="feature-list-box">
                {features.map((item, index) => (
                  <div key={index} className="list-item">
                    <div className="list-icon">
                      {item.icon}
                    </div>
                    <div className="list-text">{item.text}</div>
                    <FaArrowRight className="list-arrow" />
                  </div>
                ))}
              </div>

            </div>
          </div>

          {/* RIGHT IMAGE SECTION */}
          <div className="col-lg-6 col-xl-6 right-content-wrapper">
            <div className="image-complex-wrapper">

              <div className="circular-frame">
                <img src={bgImage || Map3} alt={title || "Banner"} className="blob-image" />
              </div>

              {/* Floating Icon Cards */}
              <div className="floating-card c-top-left shield-card">
                <FaShieldAlt className="f-icon" />
                <FaCheck className="check-mark" />
              </div>

              <div className="floating-card c-top-right tax-card">
                <span className="tax-label">TAX</span>
                <span className="tax-percent">%</span>
                <div className="tax-lines">
                  <div className="line"></div>
                  <div className="line short"></div>
                </div>
              </div>

              <div className="floating-card c-bottom-right">
                <FaChartLine className="f-icon" />
              </div>

            </div>
          </div>

        </div>

        {/* STATS PILL - MOVED TO BOTTOM LEVEL */}
        <div className="bottom-stats-container">
          <div className="stats-pill-bar">
            <div className="stats-item">
              <div className="stats-icon">
                <FaShieldAlt />
                <FaCheck className="check-small" />
              </div>
              <div className="stats-text">
                <span className="text-blue">100%</span>
                <span className="text-dark">Data Security</span>
              </div>
            </div>

            <div className="stats-divider"></div>

            <div className="stats-item">
              <div className="stats-icon">
                <FaClock />
              </div>
              <div className="stats-text">
                <span className="text-blue">Time-Saving</span>
                <span className="text-muted">& Efficient</span>
              </div>
            </div>

            <div className="stats-divider"></div>

            <div className="stats-item">
              <div className="stats-icon">
                <FaUsers />
              </div>
              <div className="stats-text">
                <span className="text-blue">Expert Support</span>
                <span className="text-muted">Always Available</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .map-banner-exact {
          background: #f8fafc;
          position: relative;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
          padding: 120px 0 0 0; /* Top padding clears fixed header, NO bottom padding */
        }

        .hero-container {
          width: 100%;
          max-width: 1440px;
          margin: 0 auto;
          padding: 0 40px;
          position: relative;
          z-index: 2;
        }

        /* BACKGROUND ELEMENTS */
        .bg-pattern-dots {
          position: absolute;
          top: 40px;
          right: 100px;
          width: 300px;
          height: 300px;
          background-image: radial-gradient(#cbd5e1 2px, transparent 2px);
          background-size: 24px 24px;
          opacity: 0.5;
          z-index: 1;
        }
        
        /* Modern Abstract SaaS Blob */
        .bg-blob-right {
          position: absolute;
          top: -20%;
          right: -10%;
          width: 65%;
          height: 140%;
          background: linear-gradient(135deg, #4d8096 0%, #165986 100%);
          border-radius: 40% 60% 30% 70% / 60% 40% 70% 40%;
          z-index: 1;
          box-shadow: -20px 20px 60px rgba(29, 78, 216, 0.15);
        }

        /* LEFT CONTENT STYLING */
        .left-content-wrapper {
          display: flex;
          align-items: center;
        }
        
        .content-left {
          width: 100%;
          max-width: 600px;
        }

        .pill-tag {
          display: inline-flex;
          align-items: center;
          background: #eff6ff;
          padding: 6px 16px 6px 6px;
          border-radius: 30px;
          color: #165986;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 24px;
          border: 1px solid rgba(29, 78, 216, 0.1);
        }
        .tag-icon-box {
          background: #fff;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          color: #165986;
          font-size: 12px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.05);
        }

        .main-heading {
          font-size: clamp(32px, 3.5vw, 48px);
          font-weight: 800;
          color: #0f172a;
          line-height: 1.2;
          margin-bottom: 24px;
          letter-spacing: -1px;
        }
        .text-blue {
          color: #165986;
        }
        
        .sub-desc {
          color: #475569;
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 32px;
          font-weight: 400;
        }

        /* FEATURE LIST (GLASSMORPHISM) */
        .feature-list-box {
          background: rgba(255, 255, 255, 0.6);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border-radius: 16px;
          padding: 12px 16px;
          width: 100%;
          max-width: 450px;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.9);
        }

        .list-item {
          display: flex;
          align-items: center;
          padding: 8px 10px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.6);
          transition: all 0.2s ease;
        }
        .list-item:last-child {
          border-bottom: none;
        }
        .list-item:hover {
          background: rgba(255, 255, 255, 0.8);
          border-radius: 8px;
          transform: translateX(4px);
        }

        .list-icon {
          width: 28px;
          height: 28px;
          background: #165986;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          margin-right: 14px;
          flex-shrink: 0;
          box-shadow: 0 4px 10px rgba(29, 78, 216, 0.2);
        }

        .list-text {
          flex-grow: 1;
          font-size: 14px;
          font-weight: 700;
          color: #1e293b;
          margin-right: 15px;
        }

        .list-arrow {
          color: #3b82f6;
          font-size: 13px;
          transition: transform 0.2s ease;
        }
        .list-item:hover .list-arrow {
          transform: translateX(4px);
          color: #165986;
        }

        /* BOTTOM STATS CONTAINER */
        .bottom-stats-container {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 40px;
          position: relative;
          z-index: 3;
        }

        /* STATS PILL BAR */
        .stats-pill-bar {
          background: #fff;
          border-radius: 50px;
          padding: 16px 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-shadow: 0 15px 35px rgba(15, 23, 42, 0.06);
          border: 1px solid #f1f5f9;
          width: 100%;
          max-width: 900px; /* Made wider so it spans nicely */
        }

        .stats-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          flex: 1;
        }
        
        .stats-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #eff6ff;
          color: #165986;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          position: relative;
        }
        .check-small {
          position: absolute;
          font-size: 8px;
          color: #fff;
          background: #10b981;
          border-radius: 50%;
          padding: 2px;
          bottom: -2px;
          right: -2px;
        }

        .stats-text {
          display: flex;
          flex-direction: column;
          line-height: 1.2;
        }
        .stats-text .text-blue { color: #165986; font-size: 14px; font-weight: 800; }
        .stats-text .text-dark { color: #0f172a; font-size: 14px; font-weight: 700; }
        .stats-text .text-muted { color: #64748b; font-size: 14px; font-weight: 500; }

        .stats-divider {
          width: 1px;
          height: 40px;
          background: #e2e8f0;
          margin: 0 20px;
        }

        /* RIGHT IMAGE SECTION */
        .right-content-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }

        .image-complex-wrapper {
          position: relative;
          width: 100%;
          max-width: 550px;
          aspect-ratio: 1 / 1;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }

        .circular-frame {
          width: 85%;
          height: 85%;
          border-radius: 50%;
          border: 8px solid #fff;
          box-shadow: 0 0 0 10px #2563eb, 0 20px 50px rgba(15, 23, 42, 0.2);
          overflow: hidden;
          position: relative;
          z-index: 2;
        }

        .blob-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }

        /* FLOATING CARDS */
        .floating-card {
          position: absolute;
          background: #fff;
          width: 65px;
          height: 65px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 15px 35px rgba(15, 23, 42, 0.15);
          z-index: 3;
          border: 1px solid #f8fafc;
          animation: floatAni 4s ease-in-out infinite;
        }
        .f-icon {
          font-size: 26px;
          color: #165986;
        }

        .c-top-left { top: 5%; left: 0; animation-delay: 0s; }
        .c-top-right { top: 15%; right: 0; animation-delay: 1.2s; }
        .c-bottom-right { bottom: 10%; right: 5%; animation-delay: 2.4s; }

        @keyframes floatAni {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        /* Custom TAX card */
        .tax-card {
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 8px;
        }
        .tax-label { font-size: 13px; font-weight: 800; color: #165986; line-height: 1; margin-bottom: 2px; }
        .tax-percent { font-size: 15px; font-weight: 800; color: #165986; line-height: 1; }
        .tax-lines { width: 100%; margin-top: 4px; display: flex; flex-direction: column; align-items: center; gap: 3px; }
        .tax-lines .line { width: 60%; height: 2px; background: #165986; border-radius: 2px; }
        .tax-lines .short { width: 40%; }

        /* Custom Shield card */
        .shield-card {
          position: relative;
        }
        .check-mark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 12px;
          font-weight: bold;
          margin-top: -1px;
        }

        /* RESPONSIVE DESIGN */
        @media (max-width: 1400px) {
          .main-heading { font-size: 46px; }
          .image-complex-wrapper { max-width: 480px; }
          .stats-pill-bar { padding: 10px 15px; }
        }

        @media (max-width: 1200px) {
          .main-heading { font-size: 38px; }
          .sub-desc { font-size: 16px; margin-bottom: 24px; }
          .image-complex-wrapper { max-width: 400px; }
          .stats-text .text-dark, .stats-text .text-muted { font-size: 11px; }
          .bg-blob-right { width: 70%; right: -15%; }
        }
        
        @media (max-width: 991px) {
          .map-banner-exact {
            min-height: auto;
            max-height: none;
            padding: 60px 0;
            text-align: center;
          }
          .hero-container { padding: 0 20px; }
          
          .bg-blob-right {
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            border-radius: 0;
            opacity: 0.1;
          }

          .left-content-wrapper {
            margin-bottom: 50px;
            justify-content: center;
          }
          
          .content-left {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .feature-list-box {
            text-align: left;
          }
          
          .stats-pill-bar {
            flex-direction: column;
            border-radius: 24px;
            gap: 15px;
            padding: 20px;
          }
          .stats-item { width: 100%; justify-content: center; }
          .stats-divider { width: 100%; height: 1px; margin: 5px 0; }
          
          .image-complex-wrapper { max-width: 380px; margin: 0 auto; }
        }

        @media (max-width: 576px) {
          .main-heading { font-size: 32px; }
          .image-complex-wrapper { max-width: 300px; }
          .circular-frame { border-width: 5px; box-shadow: 0 0 0 5px #2563eb, 0 10px 30px rgba(15, 23, 42, 0.2); }
          .floating-card { width: 50px; height: 50px; border-radius: 12px; }
          .f-icon { font-size: 20px; }
          .c-top-right { right: -10px; }
        }
        `
      }} />
    </section>
  );
}

export default MapBanner;